import type { ReactNode } from "react";
import { DeltaChip, type DeltaChipProps } from "@/components/ds";

export interface CycleHeroProps {
  /** Rótulo en versalitas ("Tu resumen del ciclo"). */
  label: string;
  /** Cifra ya formateada con flecha ("↓ -$2,040"). */
  value: string;
  /** Frase explicativa en texto plano. */
  children: ReactNode;
  /** Cambio frente al ciclo anterior. Solo si hay dato real del periodo previo. */
  delta?: Omit<DeltaChipProps, "onCard" | "size">;
}

/** Cifra del ciclo sobre tarjeta amarilla `card-sun`: una por pantalla. */
export function CycleHero({ label, value, children, delta }: CycleHeroProps) {
  return (
    <article
      aria-label={`${label}, ${value}`}
      className="rounded-[var(--ds-radius-lg)] bg-[var(--ds-card-sun)] p-5 text-[var(--ds-on-card)] md:p-7"
    >
      <div className="text-[11px] font-medium uppercase leading-[14px] tracking-[0.14em]">{label}</div>
      <div className="mt-2 font-[var(--ds-font-display)] text-[56px] leading-none tracking-[-0.04em] md:mt-3 md:text-[72px]">{value}</div>
      <p className="m-0 mt-3 text-base leading-6 md:mt-4 md:max-w-[420px] md:text-[17px] md:leading-[26px]">{children}</p>
      {delta && (
        <div className="mt-3 flex md:mt-4">
          <DeltaChip {...delta} onCard />
        </div>
      )}
    </article>
  );
}
